import React from 'react';

import ExploreIcon from 'material-ui/svg-icons/action/explore';
import DoneIcon from 'material-ui/svg-icons/action/done';

import { TextInput, SelectInput, NumberInput } from 'components/input';
import { SimpleForm } from 'components/form';

import SubsManage from './SubsManage';

import {
    DisabledExtendSelectOptions,
    DisabledExtendInputOptions,
    ExtendInputOptions,
    SubsPaymentChoices,
} from './utils'


export const SubsEditInquiry = (props) => (
    <SubsManage {...props}>
        <SimpleForm submitButtonIcon={<ExploreIcon/>} submitButtonLabel="Inquiry">
            <TextInput options={DisabledExtendInputOptions} label="Shop ID" source="id"/>
            <NumberInput options={ExtendInputOptions} label="Branch Limit" source="branch_count" />
            <SelectInput options={ExtendInputOptions} label="Payment Type" source="payment_type" choices={SubsPaymentChoices}/>
            <TextInput options={ExtendInputOptions} label="Notes" source="notes" />
        </SimpleForm>
    </SubsManage>
);

export const SubsEditConfirm = (props) => (
    <SubsManage {...props}>
        <SimpleForm submitButtonIcon={<DoneIcon/>} submitButtonLabel="Confirm">
            <TextInput options={DisabledExtendInputOptions} label="Shop ID" source="id"/>
            <NumberInput options={DisabledExtendInputOptions} label="Branch Limit" source="branch_count" />
            <SelectInput options={DisabledExtendSelectOptions} label="Payment Type" source="payment_type" choices={SubsPaymentChoices}/>
            <TextInput options={DisabledExtendInputOptions} label="Notes" source="notes" />
            <TextInput options={DisabledExtendInputOptions} label="Price" source="money_to_pay" />
        </SimpleForm>
    </SubsManage>
);


// WEBPACK FOOTER //
// ./src/routes/subscription/SubsEdit.js